/**
 * Active Toggle Component
 * 
 * @package TopBuddy
 */

import { useState } from '@wordpress/element';
import { ToggleControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import apiFetch from '@wordpress/api-fetch';

const ActiveToggle = ({ postId, isActive, isPro, onToggle }) => {
	const [isToggling, setIsToggling] = useState(false);

	const handleToggle = async () => {
		setIsToggling(true);

		try {
			const formData = new FormData();
			formData.append('action', 'topbuddy_toggle_active_bar');
			formData.append('post_id', postId);
			formData.append('action_type', isActive ? 'no' : 'yes');
			formData.append('nonce', window.topbuddyDashboard.ajaxNonce);

			const response = await fetch(window.topbuddyDashboard.ajaxUrl, {
				method: 'POST',
				body: formData,
			});

			const data = await response.json();

			if (data.success) {
				// Handle array response
				const newActiveBarIds = Array.isArray(data.data.active_bar_ids) 
					? data.data.active_bar_ids 
					: [];
				
				// Call parent callback to update state
				onToggle(postId, newActiveBarIds);
			} else {
				console.error('Toggle failed:', data.data.message);
			}
		} catch (error) {
			console.error('Error toggling active state:', error);
		} finally {
			setIsToggling(false);
		}
	};

	return (
		<ToggleControl
			checked={isActive}
			onChange={handleToggle}
			disabled={isToggling}
			label=""
			__nextHasNoMarginBottom
		/>
	);
};

export default ActiveToggle;

